const animateMatter = (options) => {
    options.selector = options?.selector || 'body';
    options.element = options?.element || document.querySelector(options.selector);

    if(!options.element) return false;

    console.log(options.selector);
    options.width = options?.width || options?.element.clientWidth || 800;
    options.height = options?.height || options?.element.clientHeight || 600;
    options.objects = options?.objects || false;
    options.allObjects = options.objects;
    options.colors = options?.colors || [];
    options.settings = options?.settings || {};
    options.bounds = options?.settings?.bounds || {};

    const beforeUpdateEvent = options?.beforeUpdate;
    const onPlayEvent = options?.onPlay;

    options.bounds = {
        thickness: 100,
        isStatic: true,
        render: {
            fillStyle: 'red'
        },
        ...options.bounds
    }

    const bodies = [];
    const elements = [];

    const debug = false;

    let isReady = false;
    let animationFrameRequest = false;

    const colors = options.colors;

    let loadedSvgs = false;

    const objectSettings = options.settings?.object || {}

    const {
        Engine,
        Events,
        Render,
        Runner,
        World,
        Body,
        Bodies,
        Common,
        Mouse,
        MouseConstraint,
        Svg,
        Bounds,
    } = Matter;

    const engine = Engine.create();
    const world = engine.world;



    const getDeviceType = () => {
        if (window.matchMedia("(max-width: 499px)").matches) {
            return "mobile";  // Width up to 767px
        } else if (window.matchMedia("(max-width: 999px)").matches) {
            return "tablet";  // Width between 768px - 1024px
        } else {
            return "desktop"; // Anything above 1000px
        }
    }

    //setInitialPosition();



    // const render = false;
    // const runner = false

    const render = Render.create({
        element: options.element,
        engine: engine,
        options: {
            width: options.width,
            height: options.height,
            showAngleIndicator: false,
            wireframes: false,
            background: 'transparent',
            showDebug: debug,
        }
    });

    const runner = Runner.create();
    // Run the engine.
    Render.run(render);
    Runner.run(runner, engine);


    const select = (root, selector) => {
        return Array.prototype.slice.call(root.querySelectorAll(selector));
    };

    const loadSvg = (url) => {
        return fetch(url)
            .then(function(response) { return response.text(); })
            .then(function(raw) {
                return (new window.DOMParser()).parseFromString(raw, 'image/svg+xml');
            });
    };

    const createBodyFromElement = (element, object) => {
        const rect = element.getBoundingClientRect();
        const parentRect = options.element.getBoundingClientRect();
        const style = window.getComputedStyle(element);
        const borderRadius = parseInt(style.getPropertyValue("border-radius"));

        // element.

        const bodySettings = {
            ...objectSettings,
            //...object.options,
        };
        bodySettings.chamfer = bodySettings.chamfer || {};
        if(borderRadius) bodySettings.chamfer.radius = borderRadius;

        // Calculate the offset based on percentage
        // const xOffset = (settings.x || 0) * (rect.width / 100);
        // const yOffset = (settings.y || 0) * (rect.height / 100);

        const xOffset = (object.x || 0);
        const yOffset = (object.y || 0);

        // Position the body within the container, adding offsets
        let xPosition = (rect.width / 2) + xOffset;
        let yPosition = (rect.height / 2) + yOffset;

        xPosition = object?.x || xPosition;
        yPosition = object?.y || yPosition;

        const yParentOffset = (object?.yParentOffset || 0);
        const xParentOffset = (object?.xParentOffset || 0);

        // xPosition = ((parentRect.width / 2)) - (rect.width * (xOffset / 100));
        // yPosition = ((parentRect.height / 2)) - (rect.height * (yOffset / 100));

        xPosition = (parentRect.width * xParentOffset) + (rect.width / 100 * xOffset);
        yPosition = (parentRect.height * yParentOffset) + (rect.height / 100 * yOffset);

        const angle = object?.rotate ? object.rotate * (Math.PI / 180) : false;

        //if(object?.position?.x) xPosition = object.position.x;
        //if(object?.position?.y) yPosition = object.position.y;
        // if(object?.angle) rotation = object.angle;

        object.position = { x: xPosition, y: yPosition };
        object.angle = angle;

        const body = Bodies.rectangle(
            xPosition,
            yPosition,
            element.offsetWidth,
            element.offsetHeight,
            bodySettings,
        );

        if(angle) Body.rotate(body, angle);

        return body;
    }

    const scaleVertices = (vertices, scaleFactor) => {
        return vertices.map(vertex => ({
            x: vertex.x * scaleFactor,
            y: vertex.y * scaleFactor
        }));
    };

    const update = (animate = true) => {
        let hasElements = false;

        options.objects.forEach(({ element, body }) => {
            if(!element) return;
            hasElements = true;

            element.style.transform = "translate("
                + (body.position.x - element.offsetWidth / 2) + "px, "
                + (body.position.y - element.offsetHeight / 2) + "px"
                + ")";
            element.style.transform += "rotate(" + body.angle + "rad)";
        });


        if(hasElements && animate) {
            // console.log("Running animation");
            animationFrameRequest = window.requestAnimationFrame(update);
        }
    }

    const setup = () => {
        const device = getDeviceType();

        console.log("Setup!");

        const width = options?.element.clientWidth || 800;
        const height = options?.element.clientHeight || 600;

        let startY = 0;
        let availableColors = [...colors];

        if(options?.allObjects) {
            if(options?.allObjects && !Array.isArray(options.allObjects)) {
                options.objects = options.allObjects[device] ?? options.allObjects;
            }

            console.log(options.objects);

            // Load the elements from the DOM
            options.objects.forEach((object) => {

                let colorIndex = Math.floor(Math.random() * availableColors.length);
                if (object.color) colorIndex = availableColors.findIndex(c => c === object.color);
                const color = availableColors[colorIndex];

                if(object?.selector) {
                    const domElement = document.querySelector(object.selector);
                    object.element = domElement;
                }

                if(object?.element) {
                    object.element.style.removeProperty('transform');
                    object.body = createBodyFromElement(object.element, object);
                }

                if(object?.vertexSet) {
                    // Remove the chosen option using splice
                    availableColors.splice(colorIndex, 1); // Removes 1 element at the random index

                    //const scaleFactor = ((width / 2) / 100) * 0.16;

                    const bounds = Bounds.create(object.vertexSet.flat());
                    const shapeWidth = bounds.max.x - bounds.min.x;
                    const shapeHeight = bounds.max.y - bounds.min.y;

                    const minScreenWidth = 320;
                    const maxScreenWidth = 2560;
                    const minScale = 0.4; // Scale at 320px
                    const maxScale = 2; // Scale at 1000px

                    const screenWidth = window.innerWidth;
                    const scaleFactor = ((maxScale - minScale) / (maxScreenWidth - minScreenWidth)) * (screenWidth - minScreenWidth) + minScale;

                    const newWidth = shapeWidth * scaleFactor; // Adjust your object size

                    // Apply scaling to each set of vertices
                    const scaledVertexSet = object.vertexSet.map(vertices => scaleVertices(vertices, scaleFactor));

                    const startX = (width - newWidth) - Common.random(0, (newWidth)); //(width * 3.2 / 4) + Common.random(0, (width / 4));
                    startY = (startY - shapeHeight * scaleFactor);

                    object.body = Bodies.fromVertices(startX , startY, scaledVertexSet, {
                        render: {
                            fillStyle: color,
                            strokeStyle: color,
                            lineWidth: 0,
                        },
                        objectSettings,
                    })
                }
            });
        }

        options.bounds.startY = startY;

        //isReady = true;
        update(false);
    }

    setup();

    // Function to load all SVGs
    const loadAllSvgObjects = () => {
        if(loadedSvgs) return Promise.resolve(); // Return a resolved promise if SVGs are already loaded

        if(options.objects.length === 0) return Promise.resolve(); // Return a resolved promise if no SVGs are provided

        // Return an array of promises for loading each SVG
        const svgLoadPromises = options.objects.map((object) => {
            const url = object?.url;
            if(!url) return Promise.resolve(); // Return a resolved promise if no URL is provided

            return loadSvg(url).then(function (root) {
                object.vertexSet = select(root, 'path').map(function (path) {
                    return Svg.pathToVertices(path, 5);
                });
            });
        });
        return Promise.all(svgLoadPromises); // Return a promise that resolves when all SVGs are loaded
    };

    loadAllSvgObjects().then(() => {
        loadedSvgs = true;
        console.log("Loaded!", options.objects);
        setup();
        renderCanvas();
    });

    const renderBounds = ({
        width = 200,
        height = 200,
        // startY = 0
    }) => {
        const thickness = options?.bounds?.thickness;

        const bottomOptions = options?.bounds.bottom || {};
        const topOptions = options?.bounds.top || {};
        const leftOptions = options?.bounds.left || {};
        const rightOptions = options?.bounds.right || {};

        const startY = options?.bounds.startY;

        //World.add(world, polygons);
        const wallHeight = (startY * -1) + 2000;
        const wallWidth = width;

        const leftWallX = thickness / 2 * -1;
        const leftWallY = height - wallHeight / 2;

        const rightWallX = wallWidth + thickness / 2;
        const rightWallY = height - wallHeight / 2;

        const topWallX = wallWidth / 2;
        const topWallY = height - wallHeight;

        const bottomWallX = wallWidth / 2;
        const bottomWallY = height + thickness / 2;

        World.add(world, [
            Bodies.rectangle(topWallX, topWallY, wallWidth, thickness, { ...options.bounds, ...topOptions }), // Top wall
            Bodies.rectangle(bottomWallX, bottomWallY, wallWidth, thickness, { ...options.bounds, ...bottomOptions }), // Bottom wall
            Bodies.rectangle(leftWallX, leftWallY, thickness, wallHeight, { ...options.bounds, ...leftOptions }), // Left wall
            Bodies.rectangle(rightWallX, rightWallY, thickness, wallHeight, { ...options.bounds, ...rightOptions }), // Right wall
        ]);

    }

    const renderVertices = (vertexSet) => {};

    const renderCanvas = () => {
        console.log("Render canvas");
        //stop();

        // Clear the world (remove all objects)
        const width = options?.element.clientWidth || 800;
        const height = options?.element.clientHeight || 600;
        const objects = options?.objects || [];

        render.options.width = width;
        render.options.height = height;
        Render.setSize(render, width, height);

        console.log(objects);

        // Render world boundaries.
        renderBounds({
            width: width,
            height: height,
            // startY: startY
        });

        // Render world bodies.
        objects.forEach(({ element, body, x, y, color = false }, index) => {
            if(!body) return;
            World.add(world, body);
        });

        // Add mouse controls.
        const mouse = Mouse.create(render.canvas);
        const mouseConstraint = MouseConstraint.create(engine, {
            mouse: mouse,
            constraint: {
                stiffness: 0.2,
                render: {
                    visible: debug
                }
            }
        });
        mouseConstraint.mouse.element.removeEventListener("wheel", mouseConstraint.mouse.mousewheel);
        World.add(world, mouseConstraint);
        render.mouse = mouse;

        // Matterjs takes over touch events, preventing swipe scrolling on mobile.
        // Remove touch events first.
        mouseConstraint.mouse.element.removeEventListener('touchstart', mouseConstraint.mouse.mousedown);
        mouseConstraint.mouse.element.removeEventListener('touchmove', mouseConstraint.mouse.mousemove);
        mouseConstraint.mouse.element.removeEventListener('touchend', mouseConstraint.mouse.mouseup);
        // Add mousedown to touchstart and enable matter js mousemove on bodies only.
        mouseConstraint.mouse.element.addEventListener('touchstart', mouseConstraint.mouse.mousedown, { passive: true });
        mouseConstraint.mouse.element.addEventListener('touchmove', (e) => {
            if (mouseConstraint.body) {
                mouseConstraint.mouse.mousemove(e);
            }
        });
        mouseConstraint.mouse.element.addEventListener('touchend', (e) => {
            if (mouseConstraint.body) {
                mouseConstraint.mouse.mouseup(e);
            }
        });

        isReady = true;
    }



    const start = () => {
        if(!isReady) return;
        Render.start(render);
        Runner.start(runner);
    }

    const play = () => {
        if(!isReady) return;

        update();


        options.objects.forEach((object) => {
            if (object?.body) {
                Body.setStatic(object.body, false);
                if(onPlayEvent) onPlayEvent(object, Matter);
            } else {
                console.warn("Body is undefined for element:", object.element);
            }
        });
    }

    const stop = () => {
        if(!isReady) return;
        isReady = false;

        World.clear(world);
        Engine.clear(engine);

        console.log("Clear canvas");
    }

    let currentWindowWidth = document.documentElement.clientWidth;
    const onResize = (e) => {
        const windowWidth = document.documentElement.clientWidth;
        if(windowWidth === currentWindowWidth) return;
        currentWindowWidth = windowWidth;
        reset();
    }

    window.addEventListener('resize', onResize);

    const reset = () => {
        if(!isReady) return;
        isReady = false;

        if(animationFrameRequest) {
            window.cancelAnimationFrame(animationFrameRequest);
            animationFrameRequest = false;
        }

        World.clear(world);
        Engine.clear(engine);

        setup();
        renderCanvas();
    }

    const destroy = () => {
        window.removeEventListener('resize', onResize);

        if(animationFrameRequest) {
            window.cancelAnimationFrame(animationFrameRequest);
            animationFrameRequest = false;
        }

        Render.stop(render);
        Runner.stop(runner);
        World.clear(world, true); // Remove all bodies and constraints without freeing the engine
        Engine.clear(engine); // Clear the engine state
        if(render?.canvas) render.canvas.remove();
        render.canvas = null;
        render.context = null;
        render.textures = {};
    }

    const restart = () => {
        if(!isReady) return;
        isReady = false;

        if(animationFrameRequest) {
            window.cancelAnimationFrame(animationFrameRequest);
            animationFrameRequest = false;
        }

        World.clear(world);
        Engine.clear(engine);

        renderCanvas();
    }

    // an example of using beforeUpdate event on an engine
    if(beforeUpdateEvent) Events.on(engine, 'beforeUpdate', (event) => beforeUpdateEvent(event, Matter));

    // renderCanvas();

    return {
        play: () => play(),
        start: () => start(),
        reset: () => reset(),
        restart: () => restart(),
        stop: () => stop(),
        destroy: () => destroy()
    };
};
